//This is a list to keep track of the enabled payment types for RFP
const enabledPaymentTypesForRequests = [
  {
    id: 0,
    name: "Earnest Money",
  },
  {
    id: 15,
    name: "Loss Draft",
  },
];

export { enabledPaymentTypesForRequests };
